module.exports = __webpack_public_path__ + "static/img/16.34287e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/16.png
// module id = LmlE
// module chunks = 0